<template>
  <v-list class="transparent" v-if="sourcesList.length">
    <v-list-item v-for="(d, i) in sourcesList" :key="i">
      <v-list-item-icon>
        <card-brand :brand="d.card.brand" />
      </v-list-item-icon>
      <v-list-item-title>
        <span class="body-2 text--secondary font-weight-medium">•••• •••• •••• {{d.card.last4}}</span>
        <v-tooltip right max-width="280px" v-if="i === 0" transition="scale-transition">
          <template v-slot:activator="{on}">
            <v-chip class="ml-4" v-on="on" color="lightBlue" small text-color="primary">Predeterminado</v-chip>
          </template>
          <span>Se utilizará por defecto cuando cobres a través de suscripciones o facturas únicas.</span>
        </v-tooltip>
      </v-list-item-title>
      <v-list-item-subtitle class="text-right">
        <v-btn @click="destroySource(d)" outlined color="red darken-2" dark retain-focus-on-click><v-icon small left>mdi-delete</v-icon>Eliminar</v-btn>
      </v-list-item-subtitle>
    </v-list-item>
  </v-list>
  <v-row v-else>
    <v-col class="pb-6 pt-4 text-center">
      <v-icon class="d-block" color="secondary" size="70">mdi-credit-card</v-icon>
      <span class="d-block subtitle-1 my-2">Sin tarjetas registradas</span>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import ListViewMixin from '@/mixins/ListViewMixin'
import CardBrand from '@/components/payments/CardBrand'
export default {
  components: {
    CardBrand
  },
  mixins: [
    ListViewMixin
  ],
  computed: mapState({
    count: state => state.payments.sourcesCount,
    sourcesList: state => state.payments.sourcesList
  }),
  methods: {
    destroySource (instance) {
      this.$dialog.warning({
        title: 'Remover fuente de pago',
        text: `
          <span class="d-block mb-4">Al remover la tarjeta no se podrá utilizar.</span>
          <span class="d-block my-4">¿Estás seguro de continuar?</span>
          <span class="d-block font-weight-medium">Esta acción no se puede deshacer</span>
        `,
        actions: [
          {
            color: 'red',
            text: 'Continuar',
            handle: () => {
              this.$store.dispatch('payments/DESTROY', {
                resource: 'sources',
                id: instance.id
              })
              .catch((error) => {
                this.$dialog.message.error(this.parseErrors(error.response.data))
              })
            }
          }
        ]
      })
    }
  }
}
</script>